<template>
  <div class="guesswhere-container">
    <div class="question content" v-if="attributes.value.question">
      <div :class="componentContentClass(attributes.value.question.title)">
        <div class="inline">
          <h4 class="subtext">Guess where?</h4>
          <h2 class="content" v-if="attributes.value.question.title" v-markdown="attributes.value.question.title"></h2>
          <div class="paragraph" v-if="attributes.value.question.p">
            <p v-for="(p,i) in attributes.value.question.p" :key="i" v-markdown="p"></p>
          </div>
        </div>
        
          <iframe-resize class="content" v-if="attributes.value.question.iframeresize" :attributes="attributes.value.question.iframeresize" ></iframe-resize>
          <div class="photogrid">
            <div :class="['photogrid-container', checkMaxColoum(attributes.value.question.photogrid)]">
              <photo :attributes="photo" v-for="(photo,index) in attributes.value.question.photogrid.photo" :key="`photo-${index}`" ></photo>
            </div>
          </div>
        
      </div>
      <div v-show="!showAnswer" class="st-btn-wrapper">
        <span @click="showAnswer = true" class="st-btn">Show answer</span>
      </div>
    </div>

    <div :class="['answer','content',{'show-answer': showAnswer}]" v-if="attributes.value.answer">
      <div :class="componentContentClass(attributes.value.answer)">
          <h4 class="subtext">Answer</h4>
          <h3 v-if="attributes.value.answer.location" v-markdown="attributes.value.answer.location"></h3>
          <static-map v-if="attributes.value.answer.staticmap" :attributes="{value:attributes.value.answer.staticmap}"></static-map>
      </div>
    </div>
  </div>
</template>

<script>
import IframeResize from './../IframeResize.vue'
import Photo from './../Photo.vue'
import StaticMap from './StaticMap.vue'
export default {
  props: ['attributes'],
  data() {
    return {
      showAnswer: false
    }
  },
  components: { StaticMap, IframeResize, Photo},
  methods: {
    componentClass (comp) {
      return ['component', 'component-' + comp.type]
    },
    componentContentStyle (comp) {
      return {
        textAlign: comp.textalign
      }
    },
    componentContentClass (comp) {
      const defaultAlign = {
        paragraph: 'inline',
        subtitle: 'inline',
        quote: 'inline',
        tweet: 'inline',
        fbpost: 'inline',
        pullout: 'inline',
        bullets: 'inline',
        photo: 'spread',
        videocontent: 'spread',
        svgfolder: 'container',
        photogrid: 'container',
        scrolly: 'container',
        iframeresize: 'container',
        datawrapper: 'inline'
      }

      const align = comp.align || defaultAlign[comp.type]
      return {
        'component-content': true,
        [align]: align,
        [comp.class]: comp.class
      }
    },
    checkMaxColoum (photo) {
      if (photo.max) {
        return `maxColumn-${photo.max}`
      }
      return
    }
  }
}
</script>

<style lang="scss">
.guesswhere-container {
  padding-top: 40px;
  .content {
    margin-bottom: 20px;
  }
  .answer {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transform: translateY(-20px);
    box-sizing: border-box;
    &.show-answer {
      max-height: none;
      overflow: auto;
      animation: slideIn 0.3s ease-in forwards;
      opacity: 1;
      transform: translateY(0);
      padding-top: 40px;
    }
    .component-content {
      border: 1px solid #BABCBE;
      border-radius: 10px;
      padding: 30px 30px 5px;
      box-sizing: border-box;
    }
  }
  .gap-30 {
    margin-bottom: 30px;
  }

  .subtext {
    color: rgba($black, 0.6);
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  .spread {
    max-width: 700px;

    @include breakpoint($d_normal) {
      padding: 0 10px;
      max-width: 860px;
    }
  }

  .inline {
    max-width: 700px;
  }

  .fullwidth {
    max-width: none;
  }

  .container {
    max-width: 1200px;
  }

  .immersive {
    padding: 0;
  }
  .paragraph {
    margin-bottom: 20px;
  }
  .photogrid {
    @include container;
    .photogrid-container {
    
      & > * {
        margin-bottom: 20px;

        &:last-of-type {
          margin-bottom: 0;
        }

        figcaption {
          padding-bottom: 0;
        }
      }

      @include breakpoint($d_medium) {
        @include grid_template(2);

        &.maxColumn-3,
        &.maxColumn {
          @include grid_template(3);
        }
        &.maxColumn-4 {
          @include grid_template(4);
        }
      }
    }
  }
  .st-btn-wrapper {
    text-align: center;
    padding-top: 20px;
  }
}
@keyframes slideIn {
  0% {
    max-height: 0;
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    max-height: 100%;
    opacity: 1;
    transform: translateY(0);
  }
}
</style>